import styled from "styled-components"
import { colors } from "../../Utils/color"
import { Link } from "react-router-dom"
import { slugify } from "../MoviesSlider"

const MovieDetailsDiv = styled.div`
    display: flex;
    gap: 15px;
    margin: 20px 10px;

    @media screen and (min-width: 768px) {
        gap: 20px;
        margin-top: 20px;
    }

    > img {
        width: 18vh;
        height: 24vh;
        border-radius: 10px;
        background-color: ${colors.secondary};

        @media screen and (min-width: 768px) {
            width: 26vh;
            height: 36vh;
        }
    }
`
export const MovieInfosDiv = styled.div`
    display: flex;
    flex-direction: column;
    gap: 5px;
    margin-top: 0;
    @media screen and (min-width: 768px) {
        gap: 10px;
        margin-top: 8px;
    }

    > p {
        display: flex;
        font-size: 0.95em;
        align-items: start;
        line-height: 1.3em;
        flex-wrap: wrap;
        margin: 0;

        @media screen and (min-width: 768px) {
            font-size: 1.1em;
            align-items: center;
            line-height: initial;
        }

        > span {
            opacity: 0.6;
            margin-right: 10px;
        }
    }
`
export const MoviesInfosLink = styled(Link)`
    font-size: 0.98em;
    color: ${colors.textColor};
    font-weight: 700;
    margin-right: 10px;
    @media screen and (min-width: 744px) {
        font-size: 1em;
    }
    &:hover {
        color: ${colors.primary};
    }
`
export const MoviesInfosButton = styled.button`
    font-size: 0.98em;
    color: ${colors.textColor};
    font-weight: 700;
    text-decoration: underline;
    background: none;
    margin-right: 5px;
    border: none;
    cursor: pointer;
    @media screen and (max-width: 744px) {
        font-size: 1em;
    }
    &:hover {
        color: ${colors.primary};
    }
`

function MovieDetails({ movieInfos, date, genres, real, acteurs, pays }) {
    return (
        <MovieDetailsDiv>
            <img src={movieInfos.cover} alt="Movie Cover" />
            <MovieInfosDiv>
                <p>
                    <span>Titre Original</span>
                    <MoviesInfosLink
                        style={{
                            cursor: "text",
                            pointerEvents: "none",
                            textDecoration: "none",
                        }}
                    >
                        {movieInfos.titre_original}
                    </MoviesInfosLink>
                </p>
                <p>
                    <span>Date de sortie</span>
                    <MoviesInfosLink
                        style={{
                            cursor: "text",
                            pointerEvents: "none",
                            textDecoration: "none",
                        }}
                    >
                        {date}
                    </MoviesInfosLink>
                </p>
                <p>
                    <span>Durée</span>
                    <MoviesInfosLink
                        style={{
                            cursor: "text",
                            pointerEvents: "none",
                            textDecoration: "none",
                        }}
                    >
                        {movieInfos.duree}
                    </MoviesInfosLink>
                </p>
                <p>
                    <span>Genres</span>
                    {genres.map((genre) => (
                        <MoviesInfosLink to={"/films?page=1&genre=" + genre}>
                            {genre}
                        </MoviesInfosLink>
                    ))}
                </p>
                <p>
                    <span>Réalisateurs</span>
                    {real.map((real) => (
                        <MoviesInfosLink
                            to={"/realisateurs/" + slugify(real)}
                            state={{ name: real }}
                        >
                            {real}
                        </MoviesInfosLink>
                    ))}
                </p>
                <p>
                    <span>Acteurs</span>
                    {acteurs.map((actors) => (
                        <MoviesInfosLink
                            to={"/acteurs/" + slugify(actors)}
                            state={{ name: actors }}
                        >
                            {actors}
                        </MoviesInfosLink>
                    ))}
                </p>
                <p
                    style={{
                        display: pays ? "none" : "flex",
                    }}
                >
                    <span>Pays d'origine</span>
                    {pays.map((pays) => (
                        <MoviesInfosLink to={"/films?page=1&pays=" + pays}>
                            {pays}
                        </MoviesInfosLink>
                    ))}
                </p>
                <p>
                    <span>Note Film</span>
                    <MoviesInfosLink
                        style={{
                            cursor: "text",
                            pointerEvents: "none",
                            textDecoration: "none",
                        }}
                    >
                        {movieInfos.note_moyenne}
                    </MoviesInfosLink>
                </p>
            </MovieInfosDiv>
        </MovieDetailsDiv>
    )
}

export default MovieDetails
